enum CustomProperty {
  conferenceId = "conferenceId",
}

export default CustomProperty;
